import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import Organization from '@/types/organizationType';

const endPoint = 'billing/getPlanDetails';
const url = apiUrl + endPoint;

const getPlanDetails = async (org: Organization) => {
  try {
    const res = await postWithAuth(url, {
      OrganizationUUID: org.OrgUUID,
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    return JSON.parse(text);
  } catch (err) {
    console.error(err);
  }
};

export default getPlanDetails;
